module.exports = __webpack_public_path__ + "static/media/allergen_wheat.e314578f.png";